import { createApp } from 'vue/dist/vue.esm-bundler';
import ArticlesAboutUs from './ArticlesAboutUs.vue';


const mountEl = document.querySelector('[data-app-articles-about-us-list]');

if ( mountEl )
{
    createApp(ArticlesAboutUs, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}